'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var DEG_TO_RAD = Math.PI / 180;
var DURATION = 1.0 / 50;
var RIBBON_COUNT = 11;
var PAPER_COUNT = 95;
var RIBBON_PARTICLE_COUNT = 30;
var RIBBON_PARTICLE_DIST = 8.0;
var RIBBON_PARTICLE_THICK = 8.0;
var RIBBON_PARTICLE_ANGLE = 45;
var RIBBON_PARTICLE_MASS = 1;
var RIBBON_PARTICLE_DRAG = 0.05;
var COLORS = [['#df0049', '#660671'], ['#00e857', '#005291'], ['#2bebbc', '#05798a'], ['#ffd200', '#b06c00']];

var CONFIG = {
	DEG_TO_RAD: DEG_TO_RAD,
	DURATION: DURATION,
	RIBBON_COUNT: RIBBON_COUNT,
	PAPER_COUNT: PAPER_COUNT,
	RIBBON_PARTICLE_COUNT: RIBBON_PARTICLE_COUNT,
	RIBBON_PARTICLE_DIST: RIBBON_PARTICLE_DIST,
	RIBBON_PARTICLE_THICK: RIBBON_PARTICLE_THICK,
	RIBBON_PARTICLE_ANGLE: RIBBON_PARTICLE_ANGLE,
	RIBBON_PARTICLE_MASS: RIBBON_PARTICLE_MASS,
	RIBBON_PARTICLE_DRAG: RIBBON_PARTICLE_DRAG,
	COLORS: COLORS,
	COLOR_INDEX: function COLOR_INDEX(colors) {
		return Math.round(Math.random() * (colors.length - 1));
	}
};

exports.default = CONFIG;